import * as React from 'react';
import { observer } from 'mobx-react';

// Components
import Box from '../../components/Box';
import Grid from '../../components/Grid';
import Icon from '../../components/Icon';
import Input from '../../components/Input';
import IconButton from '../../components/IconButton';
import Paper from '../../components/Paper';

// Component
interface IProps {
  inputValue: string;
  onInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
}
function CommentsDialogInput(props: IProps) {
  return (
    <Paper>
      <Box px={3} py={2}>
        <form onSubmit={props.onSubmit}>
          <Grid container={true}>
            <Grid
              item={true}
              style={{ flexGrow: 1, display: 'flex', alignItems: 'center' }}
            >
              <Input
                value={props.inputValue}
                onChange={props.onInputChange}
                placeholder={'Type comment here...'}
                fullWidth={true}
                disableUnderline={true}
              />
            </Grid>
            <Grid item={true}>
              <IconButton type={'submit'}>
                <Icon>send</Icon>
              </IconButton>
            </Grid>
          </Grid>
        </form>
      </Box>
    </Paper>
  );
}

export default observer(CommentsDialogInput);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/CommentsDialog/CommentsDialogInput.tsx